import React from "react";
import { Row, Col } from "antd";
import {
	QuoteProduct,
	EditQuoteProductCatalogDrawerFormValues
} from "@/Contracts/ProposalBuilder/Block";

import "../ConfigureDocumentProductDrawer.less";

import DocumentProductConfigureDrawerForm from "../DocumentProductConfigureDrawerForm/DocumentProductConfigureDrawerForm";
import { useSelector } from "react-redux";
import { GlobalState } from "@/Reducers/interface";
import BlocksActionCreators from "@/ProposalBuilder/store/actions/Blocks";
import { ProductType } from "@/Contracts/Products";
import {
	ProposalBuilderState,
	useProposalBuilderDispatch,
	useProposalBuilderSelector
} from "@/ProposalBuilder/store";
import ZDrawer from "@molecules/ZDrawer";

export const EditProductToQuoteBlockDrawer = React.memo(() => {
	const {
		isDrawerVisible,
		productData,
		blockId,
		sectionIndex,
		readonlyProductDrawer
	} = useProposalBuilderSelector((state: ProposalBuilderState) => {
		return {
			isDrawerVisible: state.blocks.isProductConfigureDrawerVisible,
			productData: state.blocks.productData,
			blockId: state.blocks.blockId,
			sectionIndex: state.blocks.sectionIndex,
			readonlyProductDrawer: state.blocks.readonlyProductDrawer
		};
	});
	const { currentActiveDocument } = useSelector((state: GlobalState) => {
		return {
			currentActiveDocument: state.documents.currentActiveDocument
		};
	});
	const proposalBuilderDispatch = useProposalBuilderDispatch();
	const handleProductClose = () =>
		proposalBuilderDispatch(
			BlocksActionCreators.hideProductConfigureDrawer()
		);
	const defaultData = productData
		? EditQuoteProductCatalogDrawerFormValues.fromQuoteProduct(productData)
		: null;
	const handleEditQuoteProduct = async (quoteProduct: QuoteProduct) => {
		await proposalBuilderDispatch(
			BlocksActionCreators.editProductInQuoteBlockSectionFromDrawer({
				blockId,
				sectionIndex,
				quoteProductId: quoteProduct.id,
				data: quoteProduct
			})
		);
	};
	const handleSubmit = (data: QuoteProduct) => {
		try {
			handleEditQuoteProduct({
				...productData,
				...data
			});
			handleProductClose();
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<ZDrawer
			visible={isDrawerVisible}
			closable={true}
			destroyOnClose={true}
			onClose={handleProductClose}
			className="document-product-drawer edit-document-product-drawer zomentum-drawer"
			title={
				<Row>
					<Col span={24}>
						<div className="drawer-title-container">
							<div className="drawer-title">
								{readonlyProductDrawer
									? "Product Details"
									: "Configure Product"}
							</div>
						</div>
					</Col>
				</Row>
			}
		>
			<DocumentProductConfigureDrawerForm
				okText="Update Product"
				defaultData={defaultData}
				onClose={handleProductClose}
				onSubmit={handleSubmit}
				currentActiveDocument={currentActiveDocument}
				isBundleProduct={
					!!productData?.bundled_products?.length ||
					productData?.product_type === ProductType.Bundle
				}
				isReadOnly={readonlyProductDrawer}
			/>
		</ZDrawer>
	);
});
